<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="Email" label="邮箱" label-width="100px" class="label-strong">
          <el-input class="popup-input-width-small" @change='checkAllInputs' placeholder="请输入邮箱" v-model="form.Email"></el-input>
        </el-form-item>
        <el-form-item label-width="100px">
          <el-button :disabled="smsBtnDisable" v-bind:type="smsBtnClass" @click="smsBtnClick" class="smsBtn">{{smsBtnText}}</el-button>
          <span>收不到验证码</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">请确认邮箱为真实邮箱或尝试再次发送，<br />若还是无法收到验证码，请联系客服</div>
            <img src="../assets/question.png">
          </el-tooltip>
        </el-form-item>
        <el-form-item prop="Code" label="验证码" label-width="100px">
          <el-input class="popup-input-width-small" @change='checkAllInputs' placeholder="请输入收到的验证码" v-model="form.Code"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="20" :xs="16" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4" :xs="8">
          <el-button :type="submitBtnClass" @click="save()">{{submitBtnName}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { sendEmail } from "../service/common.service";
import { updateEmailAddress } from "../service/student.service";
export default {
  props: {
    type: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1].contains(value), //0: 修改邮箱 1: 验证邮箱
    },
  },
  data() {
    return {
      showError: false,
      errorMessage: "",
      submitBtnClass: "info",
      smsBtnDisable: true,
      smsBtnClass: "info",
      smsBtnText: " 发送验证码 ",
      isSendSMS: false,
      timer: null,
      cc: [],
      form: {
        Email: "",
        Code: "",
        StudentId: 0,
      },
      rules: {
        Email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        Code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    submitBtnName() {
      let value = "确认修改";

      switch (this.type) {
        case 1:
          value = "确认验证";
          break;
      }

      return value;
    }
  },
  methods: {
    init() {
      this.setSMSBtnState(!this.form.Email);
    },
    setSMSBtnState(isDisable) {
      if (isDisable) {
        this.smsBtnDisable = true;
        this.smsBtnClass = "info";
      } else {
        this.smsBtnDisable = false;
        this.smsBtnClass = "primary";
      }
    },
    afterSMSSend() {
      this.isSendSMS = true;
      
      let count = 180;
      this.smsBtnText = count.toString() + "秒后重新发送";

      let self = this;
      if (self && !self._isDestroyed) {
        self.timer = setInterval(() => {
          if (self && !self._isDestroyed) {
            count--;
            if (count == 0) {
              this.isSendSMS = false;
              this.setSMSBtnState(false);
              this.smsBtnText = "发送验证码";
              clearInterval(self.timer);
            } else {
              this.smsBtnText = count.toString() + "秒后重新发送";
            }
          }
        }, 1000);
      }
    },
    async smsBtnClick() {
      if (this.isSendSMS) return;
      let sendResult = await this.sendChangeEmail();
      if (!sendResult) {
        return;
      }
    },
    async sendChangeEmail() {
      let isSuccess = false;
      if (!this.form.Email) {
        this.$message({
          message: "请先输入邮箱地址",
          type: "warning",
        });
        return isSuccess;
      }
      this.setSMSBtnState(true);
      await sendEmail(this.form.Email, this.cc, 1).then((result) => {
        if (!!result) {
          if (result.data.IsSuccess) {
            this.$message("验证码发送成功，请注意查收！");
            isSuccess = true;
            this.afterSMSSend();
          } else {
            if (result.message) {
              this.$message({
                message: result.message,
                type: "error",
              });
            }
            this.setSMSBtnState(false);
          }
        }
      });
      return isSuccess;
    },
    checkAllInputs() {
      if (!this.isSendSMS) {
        if (!!this.form.Email) {
          this.setSMSBtnState(false);
        } else {
          this.setSMSBtnState(true);
        }
      }

      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.submitBtnClass = "primary";
      });
    },
    async save() {
      this.errorMessage = "";
      this.showError = false;
      let valid = true;
      this.$refs.form.validate((v) => {
        if (!v) {
          valid = false;
        }
      });
      if (!valid) return;
      this.$data.form.StudentId = this.USERMANAGER.studentId;
      let result = await updateEmailAddress(this.$data.form);
      let msgMain = "修改邮箱";
      if (this.type === 1) {
        msgMain = "验证邮箱";
      }
      if (result) {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;

          this.$message.error(`${msgMain}失败`);
        } else {
          this.showError = false;

          this.$message.success(`${msgMain}成功`);

          if (this.type === 1) {
            this.USERMANAGER.studentEmail = this.form.Email;
            this.USERMANAGER.studentIsEmailValidated = true;
          }

          this.$refs.form.resetFields();
          this.$emit("saveSuccess", "email");
          this.$emit("closeEditor", "email");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-courseSchedule-editor {
  .el-form {
    text-align: left;
  }

  .el-input {
    &.popup-input-width-small {
      min-width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emailEditor.vue